<template>
  <TableLayout :permissions="['business:fund:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" >
      <el-form-item label="收支类型" prop="type">
        <el-select
          v-model="searchForm.type"
          placeholder="请选择收支类型"
          @change="search"
        >
          <el-option :key="0" :value="0" label="收入"></el-option>
          <el-option :key="1" :value="1" label="支出"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户昵称" prop="nickName">
        <el-input v-model="searchForm.nickName" placeholder="请输入用户昵称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="交易单号" prop="orderCode">
        <el-input v-model="searchForm.orderCode" placeholder="请输入交易单号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="平台订单号" prop="remark">
        <el-input v-model="searchForm.remark" placeholder="请输入平台订单号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="createDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="selectDate"
        />
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button type="primary" :loading="isWorking.export" v-permissions="['business:fund:exportExcel']" @click="exportExcel">导出</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        border
        stripe
      >
        <el-table-column prop="id" label="流水号" align="center" min-width="100px"></el-table-column>
        <el-table-column label="用户" align="center" min-width="100px">
          <template slot-scope="{row}">
            <div style="display: flex; line-height: 50px;">
              <el-image style="with:50px;height:50px;margin-right: 10px;" :scr="row.imgurlfull" :preview-src-list="[row.imgurlfull]"></el-image>
              {{ row.nickName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="phone" align="center" label="手机号" min-width="100px"></el-table-column>
        <el-table-column prop="type" align="center" label="收支类型" min-width="100px">
          <template slot-scope="{row}">
            {{ row.type==0?'收入':'支出' }}
          </template>
        </el-table-column>
        <el-table-column prop="num" align="center" label="金额(元)" min-width="100px"></el-table-column>
        <el-table-column prop="remark" align="center" label="平台订单号" min-width="100px"></el-table-column>
        <el-table-column prop="orderCode" align="center" label="交易单号" min-width="100px"></el-table-column>
        <el-table-column prop="content" align="center" label="说明" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" align="center" label="创建时间" min-width="100px"></el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
export default {
  name: 'Fund',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      createDate: [],
      // 搜索
      searchForm: {
        remark: '',
        type: '',
        nickName: '',
        orderCode: '',
        starttime: '',
        endtime: ''
      }
    }
  },
  created () {
    this.config({
      module: '资金明细信息表',
      api: '/business/fund',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    selectDate(v) {
      this.searchForm.starttime = v[0] + ' 00:00:00'
      this.searchForm.endtime = v[1] + ' 23:59:59'
      this.search()
    },
    reset () {
      this.createDate = []
      this.searchForm.starttime = ''
      this.searchForm.endtime = ''
      this.$refs.searchForm.resetFields()
      this.search()
    },
  },
}
</script>
